// export const srArtContext = '/srArt/newsInfo'

export default [
  {
    path: `/education`,
    name: '公共教育',
    meta: {
      title: '公共教育-上饶美术馆',
    },
    component: () => import('../views/education/Teach.vue'),
  },
  {
    path: `/education/detail`,
    name: '公共教育详请',
    meta: {
      title: '公共教育详请-上饶美术馆',
    },
    component: () => import('../views/education/Educt.vue'),
  },
  {
    path: `/education/form`,
    name: '活动报名',
    meta: {
      title: '活动报名-上饶美术馆',
    },
    component: () => import('../views/education/form.vue'),
  }
]

